import { useQuery } from '@tanstack/react-query';
import { fetchCategories } from '@/actions/search';

export const useAllCategories = (draftId?: string) => {
  const allCategoriesQuery = useQuery({
    queryKey: ['tour-categories'],
    queryFn: () => fetchCategories(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return allCategoriesQuery;
};
